// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-b79a9c3c]:export{primaryColor:#00a0df;secondaryColor:#003479;accentColor:#c41230}#countdown-seconds[data-v-b79a9c3c]{display:inline-block;width:1.35em;text-align:right}", ""]);
// Exports
module.exports = exports;
